/**
 * Non-hook analytics entry for the storage explorer (openers and services that
 * run outside React). Names come from spec §12.1; properties are enums and
 * buckets only — never a container / blob / path / account value.
 */
import type { StorageExplorerMode } from '../../core/types/workspaceTypes';

export type StorageBrowseOpenSource = 'tree' | 'pin' | 'restore' | 'mcp' | 'view-switch';
export type StorageNavigateDirection = 'into' | 'up' | 'breadcrumb' | 'back' | 'forward';

type StorageEventProps = Record<string, string | number | boolean>;

export function trackStorageEvent(eventName: string, props?: StorageEventProps): void {
  if (typeof window === 'undefined') return;
  const track = window.electronAPI?.analytics?.track;
  if (!track) return;
  track(eventName, props).catch(() => {
    /* analytics never affects UX */
  });
}

export function storageCountBucket(count: number): '0' | '1' | '2-10' | '11-100' | '101+' {
  if (count <= 0) return '0';
  if (count === 1) return '1';
  if (count <= 10) return '2-10';
  if (count <= 100) return '11-100';
  return '101+';
}

export function trackStorageBrowseOpen(mode: StorageExplorerMode, source: StorageBrowseOpenSource): void {
  trackStorageEvent('feature:storage_browse_open', { mode, source });
}

export function trackStorageNavigate(mode: StorageExplorerMode, direction: StorageNavigateDirection): void {
  trackStorageEvent('feature:storage_navigate', { mode, direction });
}
